export const FETCH_CLUSTER_NUMBER_IDP_REQUEST='FETCH_CLUSTER_NUMBER_IDP_REQUEST';
export const FETCH_CLUSTER_NUMBER_IDP_SUCCESS='FETCH_CLUSTER_NUMBER_IDP_SUCCESS';
export const FETCH_CLUSTER_NUMBER_IDP_FAILURE='FETCH_CLUSTER_NUMBER_IDP_FAILURE';